import { render, staticRenderFns } from "./CreateRules.vue?vue&type=template&id=afd7bcf8"
import script from "./CreateRules.vue?vue&type=script&lang=js"
export * from "./CreateRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports